"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _listSecteurAct = _interopRequireDefault(require("@/components/listSecteurAct"));

var _listSecteurGeo = _interopRequireDefault(require("@/components/listSecteurGeo"));

var _listClient = _interopRequireDefault(require("@/components/listClient"));

var _listEnseigne = _interopRequireDefault(require("@/components/listEnseigne"));

var _listCascaderUtilisateur = _interopRequireDefault(require("@/components/listCascaderUtilisateur"));

var _DelaiPaiementSelectList = _interopRequireDefault(require("@/components/DelaiPaiementSelectList"));

var _moment = _interopRequireDefault(require("moment"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiWorkflow = _interopRequireWildcard(require("@/api/workflow"));

var apiTva = _interopRequireWildcard(require("@/api/tva"));

var _utils = require("@/helpers/utils");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'Affaire',
  props: {
    formData: Object,
    title: String,
    action: String
  },
  components: {
    listSecteurAct: _listSecteurAct.default,
    listSecteurGeo: _listSecteurGeo.default,
    listClient: _listClient.default,
    listEnseigne: _listEnseigne.default,
    listCascaderUtilisateur: _listCascaderUtilisateur.default,
    DelaiPaiementSelectList: _DelaiPaiementSelectList.default
  },
  data: function data() {
    var _this = this;

    var validDateDebutTravaux = function validDateDebutTravaux(rule, value, callback) {
      var dtDebut = _this.dateDebutTravaux || '';

      if (dtDebut !== '') {
        if (!(0, _moment.default)(dtDebut, 'DD/MM/YYYY').isValid()) {
          callback(new Error('Date invalide'));
        }
      }

      callback();
    };

    var validDateFinTravaux = function validDateFinTravaux(rule, value, callback) {
      var dtDebut = _this.dateDebutTravaux || '';
      var dtFin = _this.dateFinTravaux || '';

      if (dtFin !== '') {
        if (!(0, _moment.default)(dtFin, 'DD/MM/YYYY').isValid()) {
          callback(new Error('Date invalide'));
        } else if ((0, _moment.default)(dtDebut, 'DD/MM/YYYY').isAfter((0, _moment.default)(dtFin, 'DD/MM/YYYY'))) {
          callback(new Error('La date de fin de travaux ne peut pas être avant la date de début'));
        }
      }

      callback();
    };

    var validRequired = function validRequired(rule, value, callback) {
      value = value || '';
      var required = rule.key && _this.workflow[rule.key] && _this.workflow[rule.key].required ? _this.workflow[rule.key].required : false;

      if (value === '' && required) {
        callback(new Error('Champ obligatoire'));
      }

      callback();
    };

    return {
      rules: {
        nom: {
          required: true,
          message: 'Champ obligatoire'
        },
        id_secteur_act: {
          required: true,
          message: 'Champ obligatoire'
        },
        id_secteur_geo: {
          required: true,
          message: 'Champ obligatoire'
        },
        id_client: {
          key: 'client',
          validator: validRequired
        },
        id_enseigne: {
          key: 'enseigne',
          validator: validRequired
        },
        date_debut_travaux: {
          validator: validDateDebutTravaux
        },
        date_fin_travaux: {
          validator: validDateFinTravaux
        },
        id_ingenieur_etude: {
          key: 'ingenieurEtude',
          validator: validRequired
        },
        id_chef_projet: {
          key: 'chefProjet',
          validator: validRequired
        },
        id_conducteur_travaux: {
          key: 'conducteurTravaux',
          validator: validRequired
        },
        id_responsable_secteur: {
          key: 'responsableSecteur',
          validator: validRequired
        },
        code_analytique_ident_ville: {
          key: 'codeIdentVille',
          validator: validRequired
        }
      },
      // ---
      dateTravaux: '',
      brouillon: false,
      tva: 20,
      // par défaut TVA de 20%
      // ---
      selection: [],
      refresh: 0,
      CONST: CONST,
      contacts: [],
      state: '',
      // -------------
      contact_maitre_ouvrage: '',
      telephone: '',
      mail: '',
      adresse1: '',
      adresse2: '',
      code_postal: '',
      ville: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    apiTva.getDefault().then(function (results) {
      _this2.tva = results && results[0] ? results[0] : 20;
    }).catch(function (error) {
      _this2.$message(error);
    });
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user', 'workflow']), {
    dureeTravaux: function dureeTravaux() {
      var dtDebut = this.formData.date_debut_travaux;
      var dtFin = this.formData.date_fin_travaux;
      var start = '';
      var end = '';
      var range = ''; // --

      if (dtDebut) {
        if (dtDebut.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)) {
          start = (0, _moment.default)(dtDebut, 'DD/MM/YYYY');
        } else {
          start = (0, _moment.default)(dtDebut, 'YYYY-MM-DD');
        }
      }

      if (dtFin) {
        if (dtFin.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)) {
          end = (0, _moment.default)(dtFin, 'DD/MM/YYYY');
        } else {
          end = (0, _moment.default)(dtFin, 'YYYY-MM-DD');
        }
      } // --


      if (start && end) {
        range = end.diff(start, 'week');

        if (!isNaN(range)) {
          return range + (range > 1 ? ' semaines' : ' semaine');
        }
      }

      return '';
    }
  }),
  methods: {
    updComptes: function updComptes() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$store.dispatch('workflow/updComptes', {
          societeShortname: _this3.user.societe_shortname,
          formData: _this3.formData,
          selection: _this3.selection
        }).then(function () {
          _this3.formData.num_chrono = _this3.workflow.numChrono;
          _this3.formData.code_analytique = _this3.workflow.codeAnalytique;
          _this3.formData.compte_auxiliaire = _this3.workflow.compteAuxilaire;
          _this3.formData.num_affaire = _this3.workflow.numAffaire;
          _this3.formData.delai_paiement = _this3.selection.client && _this3.selection.client.delai_paiement ? _this3.selection.client.delai_paiement : _this3.formData.delai_paiement;

          _this3.getContacts();

          _this3.refresh++;
        });
      });
    },
    resetForm: function resetForm() {
      this.$refs['ElForm'].resetFields();
    },
    validateForm: function validateForm() {
      var _this4 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          var msg1 = 'Voulez-vous créer ou enregistrer cette affaire comme brouillon ?';
          var msg2 = 'Nouvelle affaire';
          var msg3 = 'Créer affaire';

          if (_this4.action !== 'new') {
            msg1 = 'Voulez-vous modifier ou enregistrer cette affaire comme brouillon ?';
            msg2 = 'Modification affaire';
            msg3 = 'Enregistrer affaire';
          }

          _this4.$confirm(msg1, msg2, {
            distinguishCancelAndClose: true,
            confirmButtonText: msg3,
            cancelButtonText: 'Enregistrer comme brouillon',
            callback: function callback(btnAction) {
              if (btnAction === 'cancel' || btnAction === 'confirm') {
                _this4.brouillon = btnAction === 'cancel';

                _this4.actionSave();
              }
            }
          });
        }
      });
    },
    getData: function getData() {
      if (this.brouillon) {
        // si on a cliqué sur le bouton pour enrgistrer en mode brouillon
        this.formData.status = CONST.AFFAIRE.STATUS.DRAFT.value;
        this.formData.etape = CONST.AFFAIRE.ETAPE.AFFAIRE.value;
      } else {
        this.formData.status = CONST.AFFAIRE.STATUS.CREATED.value;
        this.formData.etape = CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value;
      }

      var data = {
        status: this.formData.status,
        etape: this.formData.etape,
        id_user: this.action === 'new' ? this.user.id : this.formData.id_user,
        id_societe: this.action === 'new' ? this.user.id_societe : this.formData.id_societe,
        id_secteur_geo: this.formData.id_secteur_geo,
        id_secteur_act: this.formData.id_secteur_act,
        id_enseigne: this.formData.id_enseigne,
        id_client: this.formData.id_client,
        delai_paiement: this.formData.delai_paiement,
        nom: this.formData.nom.toUpperCase(),
        num_affaire: this.formData.num_affaire,
        date_creation_affaire: this.action === 'new' ? (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss') : this.formData.date_creation_affaire,
        date_debut_travaux: (0, _utils.dateToSQL)(this.formData.date_debut_travaux),
        date_fin_travaux: (0, _utils.dateToSQL)(this.formData.date_fin_travaux),
        code_analytique: this.formData.code_analytique,
        code_analytique_ident_ville: this.formData.code_analytique_ident_ville,
        compte_auxiliaire: this.formData.compte_auxiliaire,
        // num_chrono: this.formData.num_chrono,
        indice: this.formData.indice,
        id_ingenieur_etude: this.formData.id_ingenieur_etude,
        id_chef_projet: this.formData.id_chef_projet,
        id_conducteur_travaux: this.formData.id_conducteur_travaux,
        id_responsable_secteur: this.formData.id_responsable_secteur,
        // ----
        contact_maitre_ouvrage: this.formData.contact_maitre_ouvrage ? this.formData.contact_maitre_ouvrage.slice(0, 99).trim() : '',
        telephone: this.formData.telephone,
        mail: this.formData.mail,
        adresse1: this.formData.adresse1,
        adresse2: this.formData.adresse2,
        ville: this.formData.ville,
        code_postal: this.formData.code_postal,
        // -----
        mt_tva: this.tva.taux,
        date_ouverture_chantier: (0, _utils.dateToSQL)(this.formData.date_ouverture_chantier),
        date_reception: (0, _utils.dateToSQL)(this.formData.date_reception)
      };
      return data;
    },
    actionSave: function actionSave() {
      var _this5 = this;

      this.$loader(true);
      var data = this.getData();
      var api = null;

      if (this.action === 'new') {
        data.societeShortname = this.user.societe_shortname;
        api = apiAffaire.insert(data);
      } else {
        api = apiAffaire.update(this.formData.id, data);
      }

      api.then(function (results) {
        // mise à jour des infos de formData qui ne sont pas directement saisies par le formulaire.
        // Nécessaire pour la mise à jour de l'historique, dans le then() suivant
        if (_this5.action === 'new') {
          _this5.formData.id = results.insertId;
        }

        _this5.formData.id_societe = data.id_societe;
        _this5.formData.status = data.status;
        _this5.formData.etape = data.etape;
      }).then(function () {
        // Mise à jour de l'historique
        if (_this5.action === 'new' && _this5.formData.status === CONST.AFFAIRE.STATUS.DRAFT.value) {
          _this5.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this5.formData, {
            message: 'Création de l\'affaire (brouillon)'
          }));
        }

        if (_this5.action === 'new' && _this5.formData.status !== CONST.AFFAIRE.STATUS.DRAFT.value) {
          _this5.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this5.formData, {
            message: 'Création de l\'affaire'
          }));
        }

        if (_this5.action === 'edit' && _this5.formData.status === CONST.AFFAIRE.STATUS.DRAFT.value) {
          _this5.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this5.formData, {
            message: 'Modification des données de l\'affaire'
          }));
        }

        if (_this5.action === 'edit' && _this5.formData.status !== CONST.AFFAIRE.STATUS.DRAFT.value) {
          _this5.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this5.formData, {
            message: 'Ouverture'
          }));
        }
      }).then(function () {
        // Envoi des notifications si on est pas en mode brouillon
        if (_this5.formData.status !== CONST.AFFAIRE.STATUS.DRAFT.value) {
          var workflow = {
            from: _this5.user.firstname + ' ' + _this5.user.lastname,
            status: _this5.formData.status,
            etape: _this5.formData.etape,
            niveau: 0,
            message: 'Nouvelle affaire créée n°: ' + _this5.formData.num_affaire,
            emailTemplate: 'vente_initiale'
          };
          apiWorkflow.sendNotifications({
            affaire: _this5.formData,
            workflow: workflow
          });
        }
      }).then(function () {
        _this5.$loader(false);

        _this5.$message('Affaire enregistrée avec succès');

        _this5.$router.push('/affaire/' + _this5.formData.id);
      }).catch(function (error) {
        _this5.$loader(false);

        _this5.$message(error);
      });
    },
    // =============================
    querySearch: function querySearch(queryString, cb) {
      var results = queryString ? this.contacts.filter(this.createFilter(queryString)) : this.contacts; // call callback function to return suggestion objects

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (contact) {
        return contact.contact_maitre_ouvrage.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelectItem: function handleSelectItem(item) {
      this.formData.contact_maitre_ouvrage = item.contact_maitre_ouvrage;
      this.formData.telephone = item.telephone;
      this.formData.mail = item.mail;
    },
    handleIconClick: function handleIconClick(ev) {
      this.formData.contact_maitre_ouvrage = '';
      this.formData.telephone = '';
      this.formData.mail = '';
    },
    getContacts: function () {
      var _getContacts = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var results;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiAffaire.getContacts({
                  id_societe: this.user.id_societe,
                  id_client: this.formData.id_client,
                  id_enseigne: this.formData.id_enseigne,
                  contact_maitre_ouvrage: this.formData.contact_maitre_ouvrage
                });

              case 2:
                results = _context.sent;
                this.contacts = results;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContacts() {
        return _getContacts.apply(this, arguments);
      }

      return getContacts;
    }()
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getContacts();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
};
exports.default = _default;